import styled from 'styled-components/native';
import {ImageBackground} from 'react-native';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  flex: 1;
`;

export const Content = styled.View`
  padding: 0 24px;
  background-color: ${({theme}) => theme.colors.background};
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  margin-top: -${RFValue(20)}px;
  padding-top: ${RFValue(20)}px;
`;

export const Form = styled.View`
  margin: 0 -24px;
`;

export const FormButton = styled.TouchableHighlight`
padding: 0 24px;
  flex-direction: row;
  height: ${RFValue(50)}px;
  justify-content: space-between;
  align-items: center;
  border-style: solid;
  border-color: ${({theme}) => theme.colors.border};
  border-bottom-width: 1px;
`;
export const FormButtonText = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
  font-family: ${({theme}) => theme.fonts.regular};
`;
export const FormButtonIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const HelpVideoContainer = styled.TouchableOpacity`
  width: 100%;
  justify-content: flex-end;
  height: ${RFPercentage(35)}px;
`;

//@ts-ignore
export const HelpVideoThumb = styled(ImageBackground)`
  width: 100%;
  height: 100%;
`;

export const VideoInfos = styled.View`
  position: absolute;
  bottom: ${RFValue(32)}px;
  padding: 0 24px;
`;

export const HelpVideoTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  margin-top: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.shape};
`;

export const HelpVideoSubtitle = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.shape};
`;

export const SecurityCard = styled.View`
  margin-top: ${RFValue(12)}px;
  padding: ${RFValue(12)}px;
  border-radius: ${RFValue(10)}px;
  background-color: ${({theme}) => theme.colors.background_secondary};
  border: 1px solid ${({theme}) => theme.colors.orange};
`;

export const SecurityCardText = styled.Text`
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
  line-height: ${RFValue(16)}px;
`;
